<template>
  <div
    v-if="showError"
    class="text-center"
  >
    {{ trans('key.time_key_error') }}
    <br>
    <br>

    <button
      type="button"
      class="btn btn-success"
      @click="$emit('reload')"
    >
      {{ trans('core.reload_page') }}
    </button>
  </div>
  <base-dynamic-key
    v-else
    :code="key"
    :url="url"
    :has-buttons="hasButtons"
    :logo="logo"
    :signed="signed"
    @backToLesson="$emit('backToLesson')"
    @stopRegistration="$emit('stopRegistration')"
  >
    <template slot="explanation">
      <div>{{ trans('key.time_key_explanation') }}</div>
      <div
        v-if="title != null"
        style="font-style:italic;margin-top:10px"
      >
        {{ title }}
      </div>
      <div
        v-if="attendances > 0"
        style="margin-top:10px; font-weight: bold"
      >
        {{ attendances }} {{ trans('core.attendances_display') }}
      </div>
    </template>

    <template slot="key-extra">
      <base-timer
        class="timer align-text"
        :time-limit="countdown"
        :time-remaining="remainingTime"
      />
    </template>
  </base-dynamic-key>
</template>

<script>
import Echo from 'laravel-echo'
import { hotp } from 'notp'
import BaseTimer from '@/employees/components/BaseTimer'
import BaseDynamicKey from '@/employees/DynamicKey/BaseDynamicKey'

export default {
  name: 'BaseTimeKeyRp',

  components: {
    BaseDynamicKey,
    BaseTimer,
  },

  props: {
    title: {
      required: false,
      type: String,
      default: null,
    },
    eventIdentifier: {
      required: true,
      type: String,
    },
    hash: {
      required: true,
      type: String,
    },
    newHashInterval: {
      required: true,
      type: Number,
    },
    hasButtons: {
      type: Boolean,
      default: true,
    },
    logo: {
      type: String,
      required: false,
      default: 'img/aatt.png',
    },
    autoRefresh: {
      type: Boolean,
      default: false,
    },
    // timestamp of server in miliseconds
    currentTime: {
      type: Number,
      required: true,
    },
    signed: {
      type: Boolean,
      required: false,
      default: false,
    },
    countdown: {
      required: false,
      type: Number,
      default: 30,
    },
    numberRegisteredStudents: {
      type: Number,
      default: 0,
      required: false,
    },
    eventId: {
      required: true,
      type: String,
    },
  },

  data () {
    return {
      remainingTime: this.countdown,
      showError: false,
      token: null,
      delta: 0,
      attendances: this.numberRegisteredStudents,
    }
  },

  computed: {
    key () {
      return `${this.eventIdentifier} ${this.token}`
    },

    url () {
      return window.location.origin + `/student/time-key/${this.eventIdentifier}${this.token}`
    },
  },

  watch: {
    remainingTime: {
      handler (newValue) {
        if (newValue === 0) {
          this.remainingTime = this.countdown
          this.newCode()
        }
      },
      immediate: true,
    },
  },

  created () {
    this.delta = new Date().getTime() - this.currentTime

    this.newCode()

    // sets the remaining time of the current code, which is the current timestamp (in s) modulo 30 s
    this.remainingTime = this.countdown - parseInt((new Date().getTime() - this.delta) % (this.countdown * 1000) / 1000)

    if (this.autoRefresh) {
      window.setInterval(() => {
        this.showError = true
      }, this.newHashInterval * 60000)
    } else {
      // AutoRefresh tpe page every 10 min
      window.setTimeout(function () {
        window.location.reload()
      }, 300000)
    }

    window.setInterval(() => {
      this.setRemainingTime()
    }, 1000)

    this.setupWebsocket()
  },

  methods: {
    newCode () {
      const base32 = require('thirty-two')
      const realTime = new Date().getTime() - this.delta
      const time = this.countdown
      const opt = {
        _t: realTime,
        // convert from TOTP to HOTP by deviding the time stamp by the window duration, which gets us an increasing counter every countdown seconds
        counter: Math.floor((realTime / 1000) / time),
      }
      this.token = hotp.gen(base32.decode(this.hash), opt)
    },

    setRemainingTime () {
      this.remainingTime = this.remainingTime - 1
    },
    setupWebsocket () {
      this.echo = new Echo({
        broadcaster: 'pusher',
        key: document.head.querySelector('meta[name="pusher-key"]').content,
        wsHost: document.head.querySelector('meta[name="pusher-host"]').content,
        wsPort: document.head.querySelector('meta[name="pusher-port"]').content,
        encrypted: true,
        disableStats: true,
        enabledTransports: ['ws', 'wss'],
      })

      this.echo.channel('attendances.' + this.eventId).listen('ChangedAttendance', (e) => {
        this.attendances = e.attendances
      })
    },
  },
}
</script>

<style scoped>
.align-text {
  text-align: center;
  margin: auto;
  width: 100%;
}
</style>
